export default {
  users: [],
  owners: []
}
